/* facets.js — instant collection filtering using Section Rendering API */

document.addEventListener("DOMContentLoaded", () => {
  const page = document.querySelector("[data-collection-page]");
  if (!page) return;

  const getForm = () => document.getElementById("facets-form");
  const sortSelect = page.querySelector("[data-sort-select]");
  const sortToggle = page.querySelector("[data-sort-toggle]");
  const sortMenu = page.querySelector("[data-sort-menu]");
  const grid = page.querySelector("[data-product-grid]");
  const facetsToggle = page.querySelector("[data-facets-toggle]");
  const facetsDrawer = page.querySelector("[data-facets-drawer]");
  const facetsAside = page.querySelector("[data-facets]");
  const sectionId = "main-collection";

  const openFilters = () => {
    facetsDrawer?.classList.add("open");
    document.body.style.overflow = "hidden";
  };
  const closeFilters = () => {
    facetsDrawer?.classList.remove("open");
    document.body.style.overflow = "";
  };

  const closeSort = () => sortMenu?.setAttribute("hidden", "");
  sortToggle?.addEventListener("click", (e) => {
    e.stopPropagation();
    if (!sortMenu) return;
    sortMenu.toggleAttribute("hidden");
  });
  document.addEventListener("click", (e) => {
    if (!e.target.closest("[data-sort-wrap]")) closeSort();
  });

  page.querySelectorAll("[data-sort-option]").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (!sortSelect) return;
      sortSelect.value = btn.dataset.sortOption;
      page.querySelectorAll("[data-sort-option]").forEach((el) => el.removeAttribute("aria-current"));
      btn.setAttribute("aria-current", "true");
      closeSort();
      applyFilters();
    });
  });

  const isMobile = () => window.matchMedia("(max-width: 989px)").matches;

  const applyView = (btnView) => {
    if (!grid) return;
    let view = String(btnView || "4");
    if (view === "list" || view === "1") view = "3";
    if (view === "2" || view === "5") view = view === "2" ? "4" : "6";

    if (isMobile()) {
      if (view === "3") view = "1";
      else view = "2";
    } else if (view !== "3" && view !== "4" && view !== "6") {
      view = "4";
    }

    grid.dataset.view = view;
    const activeBtn = isMobile() ? (view === "1" ? "3" : "4") : view;
    page.querySelectorAll("[data-grid-view]").forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.gridView === activeBtn);
    });
    try { localStorage.setItem("aaliyan-grid-view", view); } catch (e) {}
  };

  window.addEventListener("resize", () => {
    const current = grid?.dataset.view;
    if (isMobile() && !["1", "2"].includes(current)) applyView("3");
    if (!isMobile() && !["3", "4", "6"].includes(current)) applyView("4");
  });

  page.querySelectorAll("[data-grid-view]").forEach((btn) => {
    btn.addEventListener("click", () => applyView(btn.dataset.gridView));
  });

  let startView = "4";
  try {
    const saved = localStorage.getItem("aaliyan-grid-view");
    if (saved === "1" || saved === "3") startView = "3";
    else if (saved === "2" || saved === "4") startView = "4";
    else if (saved === "5" || saved === "6") startView = "6";
  } catch (e) {}
  applyView(startView);

  facetsToggle?.addEventListener("click", openFilters);

  function buildUrl() {
    const params = new URLSearchParams();

    getForm()?.querySelectorAll("[data-facet-input]").forEach(input => {
      if (input.type === "checkbox") {
        if (input.checked) params.append(input.name, input.value);
      } else if (input.value) {
        params.append(input.name, input.value);
      }
    });

    if (sortSelect?.value) params.set("sort_by", sortSelect.value);
    params.set("section_id", sectionId);

    return `${window.location.pathname}?${params.toString()}`;
  }

  async function applyFilters(pushState = true) {
    grid.style.opacity = "0.4";
    const url = buildUrl();

    try {
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newGrid = doc.querySelector("[data-product-grid]");
      const newFacets = doc.querySelector("[data-facets]");
      const newCount = doc.querySelector("[data-result-count]");
      const newPagination = doc.querySelector("[data-pagination]");

      if (newGrid) grid.innerHTML = newGrid.innerHTML;
      if (newFacets && facetsAside) facetsAside.innerHTML = newFacets.innerHTML;
      if (newCount) page.querySelector("[data-result-count]").textContent = newCount.textContent;

      const oldPagination = page.querySelector("[data-pagination]");
      if (oldPagination && newPagination) oldPagination.innerHTML = newPagination.innerHTML;
      else if (oldPagination && !newPagination) oldPagination.innerHTML = "";

      if (pushState) {
        const cleanUrl = url.replace(/([&?])section_id=[^&]+&?/, "$1").replace(/[?&]$/, "");
        window.history.pushState({}, "", cleanUrl);
      }

      document.dispatchEvent(new CustomEvent("facets:updated"));
    } catch (err) {
      console.error("Filter request failed", err);
    } finally {
      grid.style.opacity = "1";
    }
  }

  page.addEventListener("change", (e) => {
    if (e.target.matches("[data-facet-input]")) applyFilters();
  });
  sortSelect?.addEventListener("change", () => applyFilters());

  page.addEventListener("click", (e) => {
    if (e.target.closest("[data-facets-close]")) {
      e.preventDefault();
      closeFilters();
      return;
    }
    if (e.target.matches("[data-clear-filters]")) {
      e.preventDefault();
      getForm()?.querySelectorAll("[data-facet-input]").forEach(i => {
        if (i.type === "checkbox") i.checked = false; else i.value = "";
      });
      applyFilters();
    }
    const paginationLink = e.target.closest("[data-pagination] a");
    if (paginationLink) {
      e.preventDefault();
      window.scrollTo({ top: page.offsetTop - 40, behavior: "smooth" });
      fetch(`${paginationLink.href}${paginationLink.href.includes("?") ? "&" : "?"}section_id=${sectionId}`)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          grid.innerHTML = doc.querySelector("[data-product-grid]").innerHTML;
          const newPag = doc.querySelector("[data-pagination]");
          const pagEl = page.querySelector("[data-pagination]");
          if (pagEl && newPag) pagEl.innerHTML = newPag.innerHTML;
          else if (pagEl && !newPag) pagEl.innerHTML = "";
          window.history.pushState({}, "", paginationLink.href);
        });
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeFilters();
  });
});
